import styled from "styled-components";

export const Main = styled.main`
    margin: 0 auto;
    max-width: 70vw;
    width: 100%;
    display: grid;
    grid-template-areas:
        "title title"
        "article right"
        "subscribe right"
        "related-news right";
    grid-template-columns: 2fr 1fr;
    grid-template-rows: auto auto auto auto;
    @media (max-width: 1480px) {
        max-width: 80vw;
    }
    @media (max-width: 1240px) {
        max-width: 95vw;
    }
    @media (max-width: 1240px) {
        margin: 26px 20px 0 20px;
        grid-template-areas:
            "title"
            "right"
            "article"
            "subscribe"
            "related-news";
        grid-template-columns: calc(100vw - 40px);
        max-width: 100vw;
        justify-content: start;
    }
`;
